<template>
    <div class="" style="height:100%">
        <div class="selectionBar">
            <div class="flex flex-ai-c flex-jc-sb flex-wrap">
                <label>场景：</label>
                <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" style="margin-left:auto" @click="edit()">添加</el-button>
            </div>
        </div>

        <!-- 表格 -->
        <div class="table" style="height:calc( 100% - 140px )">
            <el-table ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )">
                <el-table-column prop="title" label="活动名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="username" label="活动主图" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-image class="main_pic" :src="domain + '/' + scope.row.main_pic" fit="cover" :preview-src-list="[domain + '/' + scope.row.main_pic]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="s_time" label="活动开始时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="e_time" label="活动结束时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reward.first.name" label="一等奖" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reward.second.name" label="二等奖" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reward.three.name" label="三等奖" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary" icon="el-icon-zoom-in" size="small" @click="edit(scope.row,1)"></el-button>
                            <el-button type="primary" icon="el-icon-edit" size="small" @click="edit(scope.row,2)"></el-button>
                            <el-button type="primary" icon="el-icon-delete" size="small" @click="del(scope.row)"></el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging">
                <el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count"></el-pagination>
            </div>
        </div>

        <!-- 新建框 -->
        <el-dialog :title="title" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false" width="600px">
            <el-form ref="formAuth" :rules="formRules" :model="formData" label-position="top" size="small" class="alertForm">
                <el-form-item class="hide"></el-form-item>
                <el-form-item label="名称" prop="name" style="width:100%">
                    <el-input v-model="formData.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="主图" prop="main_pic" style="width:100%">
                    <el-input v-model="formData.main_pic" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="活动时间" prop="time" style="width:100%">
                    <el-date-picker v-model="formData.time" size="small" type="daterange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="奖品" prop="reward" style="width:100%">
                    <div>
                        <el-input v-model="formData.reward" autocomplete="off"></el-input>

                    </div>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="submit()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: '添加活动',
            dialogFormVisible: false,
            formLabelWidth: '80px',
            formData: {
                time: ''
            },
            formRules: {
                name: [{
                    required: true,
                    message: '请输入活动名称',
                    trigger: 'blur'
                }],
                main_pic: [{
                    required: true,
                    message: '请输入活动主图',
                    trigger: 'blur'
                }],
                time: [{
                    required: true,
                    message: '请输入活动时间',
                    trigger: 'blur'
                }],
                reward: [{
                    required: true,
                    message: '请输入活动奖品',
                    trigger: 'blur'
                }],
            },

            list: [],

            curr: 1, //页码
            row: 20, //每页条数
            pages: 1, //总页数
            count: 0, //总条数
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            this.http.post('/admin/huodong/getList', {
                curr: this.curr,
                row: this.row,
                search: this.searchValue
            }).then(res => {
                this.list = res.list;
                this.curr = res.curr;
                this.pages = res.pages;
                this.count = res.count;
            });
        },

        edit(row, state) {
            this.$router.push({
                path: state == 1 ? 'rankingDet' : '/rankingAdd',
                query: {
                    id: row ? row.id : ''
                }
            })
        },

        del(row) {
            this.$confirm(`确定删除吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.http.post('/admin/huodong/delete', { id: row.id }).then(() => {
                    this.getList();
                    this.$message.success('已删除!');
                })
            }).catch()
        },

        submit() {
            // 验证
            this.$refs['formAuth'].validate((valid) => {
                if (valid) {
                    var apiUrl = "/admin/admin/save";
                    this.http.post(apiUrl, this.formData).then(() => {
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.getList();
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //翻页
        currentChange: function (curr) {
            this.curr = curr;
            this.getList();
        },
        //改变每页条数
        sizeChange: function (row) {
            this.row = row;
            this.getList();
        },
    }
}
</script>

<style lang="css" scoped>
</style>
